/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { Prop } from 'models/api/prop';

const controller = '/props';

export const getProps = async (
    axios: AxiosInstance,
    code: string,
    objectId: string | number | undefined = undefined
) => {
    const { data } = await axios.get<Prop[]>(controller + `/${code}`, {
        params: { objectId: objectId },
    });
    return data;
};

export const changeProps = async (
    axios: AxiosInstance,
    props: Prop[],
    objectId: string | undefined = undefined
) => {
    await axios.put(controller + `/${objectId}`, props);
};
